import { render, staticRenderFns } from "./operation-board-duty-accept-remark.vue?vue&type=template&id=3f36cb1c&scoped=true&"
import script from "./operation-board-duty-accept-remark.vue?vue&type=script&lang=js&"
export * from "./operation-board-duty-accept-remark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f36cb1c",
  null
  
)

export default component.exports